import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const Snackbar: MatSnackBarConfig = {
    duration: 3000,
    panelClass: ['Snackbar'],
    direction: 'ltr',
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
};
